export const logout = (navigate) => {
    localStorage.removeItem("app_token");
    navigate("/app-login");
  };
  